import React, { useState } from 'react';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import {
  WorksInvoiceMultipleExportMutation,
  WorksReverseInvoiceMultipleExportMutation,
} from '@pay-bill/graphql';
import { TabularExportButton } from '@pay-bill/components';
import { SimpleFileFragmentType } from '@common/graphql';

export type LineItemsMultipleExportResponse = {
  result: {
    file: SimpleFileFragmentType;
  };
};

type MutationResult = LineItemsMultipleExportResponse;
type MutationVariables = {
  entityIds: string[];
  format: 'csv' | 'tsv' | 'xlsx';
};

export const MultipleLineItemExportButton = ({
  entityIds,
  onFinish,
  entityType,
}: {
  entityIds: string[];
  entityType: 'invoice' | 'reverse_invoice';
  onFinish: () => void;
}) => {
  const LABEL_TYPE = {
    invoice: entityIds.length > 1 ? 'Invoices' : 'Invoice',
    reverse_invoice:
      entityIds.length > 1 ? 'Reverse invoices' : 'Reverse invoice',
  };

  const MUTATIONS = {
    multiple_invoice: WorksInvoiceMultipleExportMutation,
    multiple_reverse_invoice: WorksReverseInvoiceMultipleExportMutation,
  };

  const [loading, setLoading] = useState(false);
  const mutationKey: keyof typeof MUTATIONS = `multiple_${entityType}`;

  const [performExport] = useMutation<MutationResult, MutationVariables>(
    MUTATIONS[mutationKey],
    {
      onCompleted: (response) => {
        setLoading(false);
        const { downloadUrl } = response.result.file;
        if (downloadUrl) {
          window.location.href = downloadUrl;
        }

        createMessage('success', `${LABEL_TYPE[entityType]} downloaded.`);
        onFinish?.();
      },
      onError: () => {
        setLoading(false);
        createMessage('error', 'Download failed. Please try again.');
      },
    }
  );

  const exportFile = (format: 'tsv' | 'csv' | 'xlsx') => {
    setLoading(true);
    void performExport({
      variables: {
        entityIds,
        format,
      },
    });
  };

  return (
    <TabularExportButton
      loading={loading}
      onExport={exportFile}
      placement="topRight"
    >
      Export
    </TabularExportButton>
  );
};
